import * as Sentry from '@sentry/react';

export const ignoredSentryErrors = [
    // Email link Microsoft Outlook crawler compatibility error
    // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062
    'Non-Error promise rejection captured with value: Object Not Found Matching Id:',
    // Checkout third-party scripts reject with a bare response object
    'Object captured as promise rejection with keys: details, message, status',
    // Storefront queries surface upstream outages the client cannot act on
    /^(GraphQL error: )?Invalid id:/,
    // Crawler-garbled catalogue URLs fail with an empty network error
    /^Network error: ?$/,
    // Ignore network fetch errors, which are usually transient or interrupted navigation
    /^Failed to fetch/i,
    /^Network error: Failed to fetch$/i,
    /^Network error: Load failed$/i,
    // Storefront queries time out on slow instances or backgrounded tabs
    /^Network error: Timeout exceeded$/i,
    // A proxy answered a query with its own HTML error page
    /^Network error: Unexpected token '<'/,
    // Firefox reporting its own connection going away
    /^(Network error: )?NetworkError when attempting to fetch resource\.$/,
    // Android in-app WebViews report their bridge dying as our error
    /Java object is gone/,
    /window\.webkit\.messageHandlers\[IOS_BRIDGE_NO_REPLY\]\.postMessage/,
];

const pathnameOf = (url) => {
    try {
        return new URL(url).pathname;
    } catch (error) {
        return null;
    }
};

export const beforeSentrySend = (event) => {
    // Third-party tags inlined into the page report frames whose filename
    // is the document itself, '<anonymous>' or nothing at all; none of
    // those can be a frame from a bundle we build.
    const pageUrl = event.request?.url;
    const pagePath = pageUrl ? pathnameOf(pageUrl) : null;
    const isFrameOutsideOurBundle = ({ filename }) =>
        !filename || filename === '<anonymous>' || filename === pageUrl || filename === pagePath;
    const thirdPartyError = event.exception?.values?.some(
        ({ type, value, stacktrace }) =>
            ((type === 'Error' && ['Aa', 'Ba', 'Ca'].includes(value)) ||
                // Injected scripts stringify our DOM and choke on its cycles
                value?.startsWith('Converting circular structure to JSON')) &&
            (!stacktrace?.frames?.length || stacktrace.frames.every(isFrameOutsideOurBundle)),
    );
    const expiredSessionRejection = event.exception?.values?.some(({ value }) =>
        [
            'Non-Error promise rejection captured with value: undefined',
            'Network error: Response not successful: Received status code 401',
        ].includes(value),
    );
    const expiredRequest = event.breadcrumbs?.some(
        ({ category, data }) => category === 'fetch' && data?.status_code === 401,
    );
    return thirdPartyError || (expiredSessionRejection && expiredRequest) ? null : event;
};

export const populateSentryContext = (portalConfiguration) => {
    Sentry.setTag('instance', portalConfiguration.instanceCode);
};
